import { render, staticRenderFns } from "./cardAliyunBridge.vue?vue&type=template&id=2bebe9f0&"
import script from "./cardAliyunBridge.vue?vue&type=script&lang=js&"
export * from "./cardAliyunBridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports